    <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="onSelect($event)"
        [class.recommendation-wizard-open]="isRecommendationWizardOpen">
        @if (featureFlagsEnum.IntentAutomations | isFeatureFlagEnabled | async) {
            <mat-tab label="PredictiveIntent">
                <ng-template matTabContent>
                    <div class="tab-content border h-full overflow-auto px-6 py-4">
                        @if (salesintelPlans?.length) {
                            @if (recommendationWizardSource !== intentSourceEnum.SALES_INTEL) {
                                <app-intent
                                    [accountTopics]="salesintelAccountTopics"
                                    [source]="intentSourceEnum.SALES_INTEL"
                                    [plans]="salesintelPlans"
                                    [planPropertyValues]="salesintelPropertyValue"
                                    [topics]="salesintelTopics"
                                    [isLoading]="isLoading || (isLoading$ | async)"
                                    (listChange)="onListChange($event, intentSourceEnum.SALES_INTEL)"
                                    [disabled]="!(isAdmin$ | async)"
                                    [showGetRecommendations]="recommendationsEnabled"
                                    (getRecommendations)="openRecommendationWizard(intentSourceEnum.SALES_INTEL)"
                                ></app-intent>
                            } @else {
                                <app-intent-recommendation-wizard
                                    [source]="intentSourceEnum.SALES_INTEL"
                                    [accountTopics]="salesintelAccountTopics"
                                    [plans]="salesintelPlans"
                                    [planPropertyValues]="salesintelPropertyValue"
                                    [catalogTopics]="salesintelTopics"
                                    (back)="closeRecommendationWizard()"
                                    (finish)="onRecommendationWizardFinish($event)"
                                ></app-intent-recommendation-wizard>
                            }
                        } @else {
                            <ng-container [ngTemplateOutlet]="noPlanMsg"></ng-container>
                        }
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab label="Bombora Intent">
                <ng-template matTabContent>
                    <div class="tab-content border h-full overflow-auto px-6 py-4">
                        @if (bomboraPlans?.length) {
                            @if (recommendationWizardSource !== intentSourceEnum.BOMBORA) {
                                <app-intent
                                    [accountTopics]="bomboraAccountTopics"
                                    [source]="intentSourceEnum.BOMBORA"
                                    [plans]="bomboraPlans"
                                    [planPropertyValues]="bomboraPropertyValue"
                                    [topics]="bomboraTopics"
                                    [isLoading]="isLoading || (isLoading$ | async)"
                                    (listChange)="onListChange($event, intentSourceEnum.BOMBORA)"
                                    [disabled]="!(isAdmin$ | async)"
                                    [showGetRecommendations]="recommendationsEnabled"
                                    (getRecommendations)="openRecommendationWizard(intentSourceEnum.BOMBORA)"
                                ></app-intent>
                            } @else {
                                <app-intent-recommendation-wizard
                                    [source]="intentSourceEnum.BOMBORA"
                                    [accountTopics]="bomboraAccountTopics"
                                    [plans]="bomboraPlans"
                                    [planPropertyValues]="bomboraPropertyValue"
                                    [catalogTopics]="bomboraTopics"
                                    (back)="closeRecommendationWizard()"
                                    (finish)="onRecommendationWizardFinish($event)"
                                ></app-intent-recommendation-wizard>
                            }
                        } @else {
                            <ng-container [ngTemplateOutlet]="noPlanMsg"></ng-container>
                        }
                    </div>
                </ng-template>
            </mat-tab>
        } @else {
            @if (bomboraPlans?.length) {
                <mat-tab label="Bombora Intent">
                    <ng-template matTabContent>
                        <div class="tab-content border h-full overflow-auto px-6 py-4">
                            <app-intent
                                [accountTopics]="bomboraAccountTopics"
                                [source]="intentSourceEnum.BOMBORA"
                                [plans]="bomboraPlans"
                                [planPropertyValues]="bomboraPropertyValue"
                                [topics]="bomboraTopics"
                                [isLoading]="isLoading || (isLoading$ | async)"
                                (listChange)="onListChange($event, intentSourceEnum.BOMBORA)"
                                [disabled]="!(isAdmin$ | async)"
                            ></app-intent>
                        </div>
                    </ng-template>
                </mat-tab>
            }
            @if (salesintelPlans?.length) {
                <mat-tab label="SalesIntel Intent">
                    <ng-template matTabContent>
                        <div class="tab-content border h-full overflow-auto px-6 py-4">
                            <app-intent
                                [accountTopics]="salesintelAccountTopics"
                                [source]="intentSourceEnum.SALES_INTEL"
                                [plans]="salesintelPlans"
                                [planPropertyValues]="salesintelPropertyValue"
                                [topics]="salesintelTopics"
                                [isLoading]="isLoading || (isLoading$ | async)"
                                (listChange)="onListChange($event, intentSourceEnum.SALES_INTEL)"
                                [disabled]="!(isAdmin$ | async)"
                            ></app-intent>
                        </div>
                    </ng-template>
                </mat-tab>
            }
        }
    </mat-tab-group>
<ng-template #noPlanMsg>
    <div class="flex flex-col text-center justify-center h-full"><h5>In-market intent signals help you find companies who are ready to buy now. Intent signals are not currently part of your SalesIntel plan. Please contact your SalesIntel representative to add intent signals.</h5></div>
</ng-template>
